<template>
  <v-row>
    <!-- Start Single Address  -->
    <v-col
      lg="4"
      md="4"
      sm="6"
      cols="12"
      v-for="(address, i) in addressContent"
      :key="i"
    >
      <div class="rn-address" :class="address.isAddress">
        <div class="icon" v-html="iconSvg(address.icon)"></div>
        <div class="inner">
          <h4 class="heading-title">{{ address.title }}</h4>
          <p>
            <a :href="address.to1">{{ address.info1 }}</a>
          </p>
          <p>
            <a :href="address.to2">{{ address.info2 }}</a>
          </p>
        </div>
      </div>
    </v-col>
    <!-- End Single Address  -->
  </v-row>
</template>

<script>
  import feather from "feather-icons";
  export default {
    data() {
      return {
        addressContent: [
          {
            icon: "phone",
            title: "Contact Phone Number",
            info1: "(+63) 998 390 9576",
            info2: "",
            to1: "tel:+639983909576",
            to2: "",
          },
          {
            icon: "mail",
            title: "Our Email Address",
            info1: "admin@rad-softwares.com",
            info2: "",
            to1: "mailto:admin@rad-softwares.com",
            to2: "",
          },
          {
            icon: "map",
            title: "Our Location",
            info1: "Brgy North Signal Village, Taguig City, 1632",
            info2: "",
            isAddress: "addres-last",
          },
        ],
      };
    },
    methods: {
      iconSvg(icon) {
        return feather.icons[icon].toSvg();
      },
    },
  };
</script>

<style lang="scss">
  .addres-last {
    p {
      pointer-events: none;
    }
  }
</style>
